import { rem, SystemStyleObject } from '@vimeo/bokeh';

export const FULL_WIDTH_ABSOLUTE_STYLE = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

export const STRICT_16BY9_BOX_STYLE: SystemStyleObject = {
  paddingTop: '56.25%',
  width: '100%',
  position: 'relative',
};

export const PREVIEW_GRADIENT: string = `
  radial-gradient(
    50% 50% at 50% 50%,
    rgba(255, 255, 255, 0.08) 0%,
    rgba(255, 255, 255, 0) 100%
  ), #282828
`;

export const STRICT_16BY9_BOX_PREVIEW_STYLE = {
  ...STRICT_16BY9_BOX_STYLE,
  borderRadius: 'subtle',
  userSelect: 'none',
  background: PREVIEW_GRADIENT,
};

export const HOVER_UNDERLINE_LINK_STYLE: SystemStyleObject = {
  color: 'blue.500',
  textDecoration: 'underline',
};

export const createFullWidthAbsoluteStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

export const NO_SELECTION: string = `
  user-select: none;
`;

export const CENTERED_FLEX: string = `
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SIDEBAR_COLLAPSED_WIDTH: string = rem(72);

export const SIDEBAR_EXPANDED_WIDTH: string = rem(360);

export const GUEST_SIDEBAR_EXPANDED_WIDTH: string = rem(256);

export const EMOJI_FONT_FAMILY: string = `-apple-system, BlinkMacSystemFont, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`;

export function createChessBackgroundStyle(theme: string): SystemStyleObject {
  return {
    backgroundColor: theme === 'dark' ? 'grayscale.800' : 'grayscale.100',
    backgroundSize: `${rem(16)} ${rem(16)}`,
    backgroundPosition: `0 0, ${rem(8)} ${rem(8)}`,
    backgroundImage:
      theme === 'dark'
        ? `linear-gradient(
          45deg,
          #3d3d3d 26%,
          transparent 26%,
          transparent 74%,
          #3d3d3d 74%,
          #3d3d3d
        ),
        linear-gradient(
          45deg,
          #3d3d3d 26%,
          transparent 26%,
          transparent 74%,
          #3d3d3d 74%,
          #3d3d3d
        )`
        : `linear-gradient(
          45deg,
          white 26%,
          transparent 26%,
          transparent 74%,
          white 74%,
          white
        ),
        linear-gradient(
          45deg,
          white 26%,
          transparent 26%,
          transparent 74%,
          white 74%,
          white
        )`,
  };
}

/**
 * @deprecated
 * @returns generic theme-dependent icon styling for emotion sx usage
 */
export function createSvgStyle({
  size = 24,
  color = 'text-primary',
}: {
  size?: number | string;
  color?: string;
} = {}) {
  return {
    svg: {
      width: size,
      height: size,
      path: {
        fill: color,
      },
    },
  };
}
